import { envConfig } from "../constants/api-endpoint";
import { DATE_FORMATS } from "../constants/app-constant";
import { formatDate } from "../utility/common-methods";
import { httpPost } from "../utility/requestHelper";
import { SET_INLINE_FILTER } from "./actionTypes";

const setInlineFilters = (payload) => ({
  type: SET_INLINE_FILTER,
  payload,
});

export const fetchInlineFilter = ({
  client_id,
  edition,
  entity,
  to_date,
  from_date,
  media_type,
}) => {
  return (dispatch) => {
    const params = {
      client_id,
      media_type,
      fromDate: formatDate(from_date, DATE_FORMATS.YYYYMMDD_dash),
      toDate: formatDate(to_date, DATE_FORMATS.YYYYMMDD_dash),
      filter_list: [
        "TopMediaDataPrint",
        "TopJournalistDataOnline",
        "TopJournalistDataPrint",
        "TopPublicationClientPrint",
        "TopPublicationClientOnline",
      ],
    };
    if (edition && edition.length) {
      params.edition = [edition];
    }
    if (entity && entity.length) {
      params.entity = entity;
    }
    httpPost(envConfig.WIDGET_INLINE_FILTER, params).then((response) => {
      const data = response && response.data && response.data.result;
      if (data) {
        dispatch(setInlineFilters(data));
      }
    });
  };
};
